(function ($) {
	$(document).ready(function () {
		galleryGridSquares();
	});
	$(window).resize(function () {
		galleryGridSquares();
	});

	function galleryGridSquares() {
		var image = $('.gg__block .image');
		var width = image.width();
		var height = width + 'px';

		image.css('height', height);
	}

	/*
    Signup button launch
    */
	$('body').on('click', '.signup-button', function (e) {
		e.preventDefault();
		$('.sp-form-outer-wrap').removeClass('closed');
	});

	/*
    Singup button close
     */
	$('body').on('click', '.sp-form-outer-wrap .close', function (e) {
		e.preventDefault();
		$('.sp-form-outer-wrap').addClass('closed');
	});

	$(window).load(function () {
		//SVG Detection...
		if (SVGsupport()) {
			$('#body-wrapper').addClass('svg');
		}

		$('.js-hidden').fadeOut().removeClass('js-hidden').fadeIn();

		var width = $(window).width(),
			height = $(window).height();
		if (width >= 1150) {
			//Enable MatchHeight on larger screens
			$('.matchHeight').matchHeight({
				byRow: false,
				property: 'height',
				target: null,
				remove: false,
			});
		}

		$('.menu-selector .button').click(function () {
			var target = $(this).data('menu');
			console.log(target);
			$('.menu-selector .button').removeClass('active');
			$(this).addClass('active');
			$('.menu-items').removeClass('active');
			$('.menu-items#' + target).addClass('active');
		});

		$('.popup-link').click(function (event) {
			event.preventDefault();
			var target = $(this).data('popup');
			$('.popups').addClass('active');
			$('.popup-box.' + target).addClass('active');
			$('body').addClass('no-scroll');
		});

		$('.close-button').click(function () {
			$('.popup-box.active').removeClass('active');
			setTimeout(function () {
				$('.popups').removeClass('active');
			}, 350);
			$('body').removeClass('no-scroll');
		});

		var isMobile = false;
		function isMobileCheck() {
			if ($('.desktop-header .tripadvisor-logo').css('display') == 'none') {
				isMobile = true;
			} else {
				isMobile = false;
			}
		}
		isMobileCheck();
		$(window).on('resize', function () {
			isMobileCheck();
		});

		function scrollCheck() {
			var shrinkHeader =
				$(window).height() -
				120; /*Defines how many pixels you scroll before the header shrinks*/
			var scroll = getCurrentScroll();

			if (scroll >= shrinkHeader) {
				$('#header').addClass('fixed');
			} else {
				$('#header').removeClass('fixed');
			}
			//   $('body').addClass('scrolled');
			//   $('#header').css('top','0px');
			// } else {
			//   $('body').removeClass('scrolled');
			//   $('#header').css('top', $( window ).height() - $('#header').outerHeight() - getCurrentScroll());
			// }
		}

		// function fixToBottom() {
		//   if ( !isMobile ) {
		//     $('#header').css('position','fixed');
		//     $('#header').css('top', $( window ).height() - $('#header').outerHeight());

		//    scrollCheck();
		//   } else {
		//     $('#header').css('position','fixed');
		//     $('#header').css('top', '0');
		//   }
		// }

		// fixToBottom();
		// $(window).on('resize', function() {
		//   fixToBottom();
		// });

		if ($('body').hasClass('home')) {
			scrollCheck();

			$(window).on('scroll', function () {
				if (!isMobile) {
					scrollCheck();
				}
			});
		}

		var nextArrow = '/wp-content/themes/carstens/images/svg/arrow-right.svg';
		var prevArrow = '/wp-content/themes/carstens/images/svg/arrow-left.svg';

		var i = 1;
		do {
			//Create a slick instance for full page images slider

			$('.fpi__slick-' + i).slick({
				speed: 300,
				dots: false,
				arrow: true,
				nextArrow: "<img class='slick-arrow slick-next' src='" + nextArrow + "'>",
				prevArrow: "<img class='slick-arrow slick-prev' src='" + prevArrow + "'>",
			});

			i++;
		} while ($('.fpi__slick-' + i).length > 0);

		//Map Overlay
		$('.map-overlay').click(function () {
			$(this).addClass('hidden');
		});

		//FB Share page JS
		$('.fbShare').click(function (event) {
			event.preventDefault();
			FB.ui(
				{
					method: 'share',
					href: window.location.href,
				},
				function (response) {}
			);
		});
		//FB Share page JS END

		//OT Magix is done - show widget
		$('#OT_searchWrapperAll').addClass('loaded');

		if (window.location.hash) {
			var hash = window.location.hash; //Puts hash in variable, and removes the # character
			$('html, body')
				.stop()
				.animate(
					{
						scrollTop: $(hash).offset().top - 100,
					},
					750
				);
		}

		$('header .smoothscroll').click(function () {
			if (!$(this).parent().hasClass('ignore-smoothscroll')) {
				var link = $(this).attr('href');
				var scroll_link = link.replace('/', '');

				$('html, body')
					.stop()
					.animate(
						{
							scrollTop: $(scroll_link).offset().top - 100,
						},
						750
					);

				//location.hash = $(this).attr('href'); //Update page # for analytics
				if (width <= 1150) {
					//If mobile nav, hide nav and resset hamburger
					$('.nav-hamburger').toggleClass('active');
					$('.desktop-header').toggleClass('active');
				}
				return false;
			}
		});
		//Mobile nav
		$('.nav-hamburger, .close-button-container .close-btn').click(function (event) {
			event.preventDefault();
			$('.nav-hamburger').toggleClass('active');
			$('.desktop-header').toggleClass('active');
		});

		if ($(".news-carousel.owl-carousel .image").length > 1) {
			$(".news-carousel.owl-carousel").owlCarousel({
				items: 1,
				loop: true,
				smartSpeed: 1500,
				autoplay: true,
				dots: true,
			});
		}

		// Custom Popup code
		if ($('.custom-popup').length) {
			const cp = $('.custom-popup');

			// Only show popup if user cookie consent given
			// Show only if cookie banner is accepted and popup hasn't been viewed
			const userConsent = getCookie('moove_gdpr_popup');
			let thirdPartyConsent = false;
			if (userConsent) {
				const decodedConsent = decodeURIComponent(userConsent);
				const jsonConsent = JSON.parse(decodedConsent);
				thirdPartyConsent = jsonConsent.thirdparty === '1';
			}

			if (!getCookie('hide_custom_popup') && thirdPartyConsent) {
				setTimeout(() => {
					$('body').addClass('popup-showing');
					cp.addClass('showing');
				}, 1500);
			}

			$('.js__close-custom-popup').on('click', function (e) {
				$('body').removeClass('popup-showing');
				cp.removeClass('showing');

				setCookie('hide_custom_popup', true);
			});
		}
	});

	function setCookie(cname, cvalue) {
		var date = new Date();
		var expires = 'expires=';
		date.setDate(date.getDate() + 1);
		expires += date.toGMTString();
		document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
	}

	function getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	function SVGsupport() {
		return document.implementation.hasFeature(
			'http://www.w3.org/TR/SVG11/feature#Image',
			'1.1'
		);
	}

	/*
        Gallery Module
    */

	//Gallery Select logic
	$('.filters li').click(function () {
		var sectionIndex = $(this).data('filter');
		console.log(sectionIndex);
		if ($(this).hasClass('active')) return;

		$(this).siblings().removeClass('active');
		$(this).addClass('active');

		$('.js__gallery-section').css('display', 'none');
		$('.js__gallery-section[data-gallery-section="' + sectionIndex + '"]').css(
			'display',
			'flex'
		);
	});

	$('.gallery .gallery-image .image-wrapper').on('click', function (e) {
		e.preventDefault();
	});

	// Gallery Slider
	var i = 0;
	// Loop through to allow for multiple sliders on the page
	$('.js__gallery-slider').each(function () {
		$(this).addClass('js__gallery-slider--' + i);

		$('.js__gallery-slider--' + i).slick({
			slidesToShow: 1,
			dots: false,
			arrows: false,
			fade: true,
		});

		i++;
	});

	$('.js__open-gallery-slider').on('click', function (e) {
		e.preventDefault();

		var slideIndex = $(this).data('index');
		var sliderIndex = $(this).closest('.js__gallery-section').data('gallery-section');
		var slider = $('.js__gallery-slider--' + sliderIndex);

		slider.closest('.gallery__slider-popup').addClass('is-active');
		slider.slick('slickGoTo', slideIndex);

		$('body').css('overflow', 'hidden');
	});

	$('.js__close-gallery-slider-popup').on('click', function (e) {
		e.preventDefault();
		$('.gallery__slider-popup').removeClass('is-active');
		$('body').css('overflow', 'auto');
	});

	$('.gallery__slider-arrow--prev').on('click', function (e) {
		$(this).siblings('.js__gallery-slider').slick('slickPrev');
	});
	$('.gallery__slider-arrow--next').on('click', function (e) {
		$(this).siblings('.js__gallery-slider').slick('slickNext');
	});

	$('.gallery__slider-bg').on('click', function (e) {
		$('.gallery__slider-popup').removeClass('is-active');
		$('body').css('overflow', 'auto');
	});

	$(document).keydown(function (e) {
		if (e.which === 27) {
			$('.gallery__slider-popup').removeClass('is-active');
			$('body').css('overflow', 'auto');
		}
		if (e.which === 37) {
			$('.gallery__slider-arrow--prev').siblings('.js__gallery-slider').slick('slickPrev');
		}
		if (e.which === 39) {
			$('.gallery__slider-arrow--next').siblings('.js__gallery-slider').slick('slickNext');
		}
	});
})(jQuery);

//https://snazzymaps.com/style/151/ultra-light-with-labels
// When the window has finished loading create our google map below
google.maps.event.addDomListener(window, 'load', init);

function init() {
	// Basic options for a simple Google Map
	// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
	var mapOptions = {
		// How zoomed in you want the map to start at (always required)
		zoom: 17,
		scrollwheel: false,

		// The latitude and longitude to center the map (always required)
		center: new google.maps.LatLng(52.3772312, 4.896951),

		// How you would like to style the map.
		// This is where you would paste any style found on Snazzy Maps.
		styles: [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [{ color: '#ffffff' }, { lightness: 17 }],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [{ color: '#ffffff' }, { lightness: 18 }],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [{ color: '#ffffff' }, { lightness: 16 }],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [{ color: '#dedede' }, { lightness: 21 }],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }],
			},
			{ elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [{ color: '#fefefe' }, { lightness: 20 }],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
			},
		],
	};

	// Get the HTML DOM element that will contain your map
	// We are using a div with id="map" seen below in the <body>
	var mapElement = document.getElementById('map-wrapper');

	// Create the Google Map using our element and options defined above
	var map = new google.maps.Map(mapElement, mapOptions);

	var marker = new google.maps.Marker({
		position: { lat: 52.3772312, lng: 4.896951 },
		map: map,
		animation: google.maps.Animation.DROP,
		title: 'Carstens',
	});
}
